const cancelledTaskIds = new Set();

export function cancelAiCopywritingTask(taskId) {
  if (taskId == null || taskId === '') return;
  cancelledTaskIds.add(String(taskId));
}

export function clearAiCopywritingTaskCancel(taskId) {
  if (taskId == null || taskId === '') return;
  cancelledTaskIds.delete(String(taskId));
}

export function isAiCopywritingTaskCancelled(taskId) {
  if (taskId == null || taskId === '') return false;
  return cancelledTaskIds.has(String(taskId));
}
